export const categoryComics = [
  {
    id: 101,
    title: "云缨巡街",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20female%20warrior%20walking%20through%20ancient%20Chinese%20street%20at%20night%2C%20lantern%20lights%2C%20traditional%20architecture%2C%20dynamic%20pose%2C%20ink%20wash%20painting%20style%20with%20modern%20manga%20aesthetic%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20composition%2C%20soft%20gradient%20background%2C%20artistic%20rendering&width=800&height=1100&seq=cat-comic-01&orientation=portrait",
    category: "热血",
    slug: "rexue",
    views: "1280万",
    rating: 9.6,
    tags: ["热血", "武侠"],
  },
  {
    id: 102,
    title: "斗破苍穹",
    author: "天蚕土豆",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20young%20male%20cultivator%20with%20flame%20energy%20surrounding%20him%2C%20martial%20arts%20fantasy%20scene%2C%20dramatic%20lighting%2C%20fiery%20orange%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20ink%20and%20digital%20hybrid%20style%2C%20clean%20dark%20background%20with%20subtle%20glow%20effects%2C%20professional%20manga%20art&width=800&height=1100&seq=cat-comic-02&orientation=portrait",
    category: "热血",
    slug: "rexue",
    views: "2560万",
    rating: 9.8,
    tags: ["玄幻", "热血"],
  },
  {
    id: 103,
    title: "武炼巅峰",
    author: "莫默",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20scene%20with%20a%20warrior%20standing%20on%20cliff%20edge%20overlooking%20vast%20mountain%20range%2C%20dramatic%20lightning%20in%20sky%2C%20epic%20scale%20composition%2C%20dark%20blue%20and%20gold%20tones%2C%20fantasy%20martial%20arts%20atmosphere%2C%20digital%20art%20style%2C%20clean%20majestic%20illustration&width=800&height=1100&seq=cat-comic-03&orientation=portrait",
    category: "热血",
    slug: "rexue",
    views: "890万",
    rating: 9.3,
    tags: ["玄幻", "热血"],
  },
  {
    id: 104,
    title: "星辰变",
    author: "我吃西红柿",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20space%20fantasy%20scene%20with%20a%20cultivator%20floating%20among%20stars%20and%20galaxies%2C%20cosmic%20energy%20swirling%20around%20him%2C%20deep%20blue%20and%20purple%20nebula%20background%2C%20ethereal%20atmosphere%2C%20digital%20art%20style%2C%20clean%20breathtaking%20composition&width=800&height=1100&seq=cat-comic-04&orientation=portrait",
    category: "热血",
    slug: "rexue",
    views: "760万",
    rating: 9.1,
    tags: ["仙侠", "热血"],
  },
  {
    id: 201,
    title: "狐妖小红娘",
    author: "小新",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20beautiful%20fox%20spirit%20girl%20with%20flowing%20pink%20hair%20in%20traditional%20red%20hanfu%2C%20romantic%20fantasy%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20ethereal%20lighting%2C%20watercolor%20and%20digital%20art%20style%2C%20warm%20pink%20and%20cream%20tones%2C%20clean%20dreamy%20composition%2C%20high%20quality%20anime%20illustration&width=800&height=1100&seq=cat-comic-05&orientation=portrait",
    category: "恋爱",
    slug: "lianai",
    views: "1890万",
    rating: 9.5,
    tags: ["恋爱", "奇幻"],
  },
  {
    id: 202,
    title: "魔道祖师",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20with%20two%20male%20characters%20in%20flowing%20white%20and%20black%20robes%2C%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20elegant%20and%20mysterious%20atmosphere%2C%20black%20ink%20and%20gold%20accents%2C%20traditional%20Chinese%20painting%20influence%20with%20modern%20manga%20style%2C%20clean%20dramatic%20composition&width=800&height=1100&seq=cat-comic-06&orientation=portrait",
    category: "恋爱",
    slug: "lianai",
    views: "3020万",
    rating: 9.9,
    tags: ["仙侠", "耽美"],
  },
  {
    id: 203,
    title: "甜美的咬痕",
    author: "伊凯/锐思",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20romantic%20scene%20with%20a%20couple%20close%20together%20in%20soft%20romantic%20lighting%2C%20gothic%20elegant%20atmosphere%2C%20dark%20red%20and%20silver%20palette%2C%20passionate%20intimate%20mood%2C%20manga%20art%20style%2C%20clean%20emotional%20composition&width=800&height=1100&seq=cat-comic-07&orientation=portrait",
    category: "恋爱",
    slug: "lianai",
    views: "650万",
    rating: 9.2,
    tags: ["恋爱", "吸血鬼"],
  },
  {
    id: 204,
    title: "怦然心动",
    author: "kid岁",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20high%20school%20romance%20scene%20with%20young%20couple%20in%20school%20uniforms%2C%20cherry%20blossom%20trees%20in%20background%2C%20soft%20pastel%20colors%2C%20innocent%20sweet%20atmosphere%2C%20watercolor%20manga%20style%2C%20clean%20youthful%20composition&width=800&height=1100&seq=cat-comic-08&orientation=portrait",
    category: "恋爱",
    slug: "lianai",
    views: "1120万",
    rating: 9.4,
    tags: ["恋爱", "校园"],
  },
  {
    id: 301,
    title: "一人之下",
    author: "米二",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20action%20scene%20with%20a%20male%20character%20using%20energy%20powers%2C%20urban%20fantasy%20setting%2C%20modern%20Chinese%20city%20backdrop%2C%20bold%20dynamic%20composition%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20semi-realistic%20manga%20style%2C%20dramatic%20lighting%20effects%2C%20clean%20character-focused%20illustration&width=800&height=1100&seq=cat-comic-09&orientation=portrait",
    category: "悬疑",
    slug: "xuanyi",
    views: "2150万",
    rating: 9.7,
    tags: ["异能", "都市"],
  },
  {
    id: 302,
    title: "诡秘之主",
    author: "爱潜水的乌贼",
    cover: "https://readdy.ai/api/search-image?query=Dark%20gothic%20manhua%20scene%20with%20mysterious%20occult%20symbols%20and%20candlelight%2C%20a%20cloaked%20figure%20standing%20before%20ancient%20tome%2C%20deep%20purple%20and%20black%20palette%2C%20occult%20atmosphere%2C%20digital%20art%20style%2C%20clean%20mysterious%20composition&width=800&height=1100&seq=cat-comic-10&orientation=portrait",
    category: "悬疑",
    slug: "xuanyi",
    views: "1200万",
    rating: 9.6,
    tags: ["悬疑", "西幻"],
  },
  {
    id: 303,
    title: "盗墓笔记",
    author: "南派三叔",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20tomb%20raiding%20scene%20with%20ancient%20underground%20passage%20and%20mysterious%20artifacts%2C%20dim%20torch%20lighting%2C%20dust%20and%20cobwebs%2C%20adventurous%20atmosphere%2C%20warm%20amber%20and%20dark%20brown%20palette%2C%20digital%20art%20style%2C%20clean%20suspenseful%20composition&width=800&height=1100&seq=cat-comic-11&orientation=portrait",
    category: "悬疑",
    slug: "xuanyi",
    views: "980万",
    rating: 9.4,
    tags: ["悬疑", "探险"],
  },
  {
    id: 304,
    title: "端脑",
    author: "壁水羽",
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20manhua%20scene%20with%20human%20brain%20connected%20to%20digital%20network%2C%20neon%20circuit%20lines%20glowing%2C%20futuristic%20holographic%20displays%2C%20cool%20blue%20and%20white%20palette%2C%20cyberpunk%20atmosphere%2C%20digital%20art%20style%2C%20clean%20mind-bending%20composition&width=800&height=1100&seq=cat-comic-12&orientation=portrait",
    category: "悬疑",
    slug: "xuanyi",
    views: "540万",
    rating: 9.0,
    tags: ["悬疑", "科幻"],
  },
  {
    id: 401,
    title: "全职高手",
    author: "蝴蝶蓝",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20gaming%20theme%20with%20a%20cool%20male%20character%20holding%20gaming%20controller%2C%20futuristic%20digital%20background%20with%20neon%20lights%2C%20dynamic%20action%20feel%2C%20silver%20and%20cyan%20accents%20on%20dark%20background%2C%20modern%20manga%20illustration%20style%2C%20clean%20sharp%20composition&width=800&height=1100&seq=cat-comic-13&orientation=portrait",
    category: "搞笑",
    slug: "gaoxiao",
    views: "1670万",
    rating: 9.4,
    tags: ["游戏", "竞技"],
  },
  {
    id: 402,
    title: "非人哉",
    author: "一汪空气",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20scene%20with%20mythological%20creatures%20in%20modern%20office%20setting%2C%20nine-tailed%20fox%20using%20computer%2C%20dragon%20drinking%20coffee%2C%20bright%20colorful%20cartoon%20style%2C%20playful%20humorous%20atmosphere%2C%20clean%20fun%20composition&width=800&height=1100&seq=cat-comic-14&orientation=portrait",
    category: "搞笑",
    slug: "gaoxiao",
    views: "820万",
    rating: 9.3,
    tags: ["搞笑", "神话"],
  },
  {
    id: 403,
    title: "我家大师兄脑子有坑",
    author: "凌宇沫",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20scene%20with%20exaggerated%20funny%20expressions%20on%20cultivation%20characters%2C%20bright%20colorful%20background%2C%20comedic%20action%20lines%2C%20cartoonish%20chibi%20style%20elements%2C%20cheerful%20atmosphere%2C%20clean%20humorous%20composition&width=800&height=1100&seq=cat-comic-15&orientation=portrait",
    category: "搞笑",
    slug: "gaoxiao",
    views: "710万",
    rating: 9.1,
    tags: ["搞笑", "仙侠"],
  },
  {
    id: 404,
    title: "快把我哥带走",
    author: "幽灵",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20sibling%20comedy%20scene%20with%20brother%20and%20sister%20fighting%20and%20bickering%20in%20funny%20poses%2C%20domestic%20house%20setting%2C%20bright%20warm%20colors%2C%20humorous%20expressions%2C%20manga%20art%20style%2C%20clean%20lively%20composition&width=800&height=1100&seq=cat-comic-16&orientation=portrait",
    category: "搞笑",
    slug: "gaoxiao",
    views: "950万",
    rating: 9.2,
    tags: ["搞笑", "日常"],
  },
  {
    id: 501,
    title: "三体漫画",
    author: "刘慈欣/改编",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20scene%20with%20three%20body%20problem%20visualization%2C%20celestial%20bodies%20orbiting%20in%20complex%20patterns%2C%20deep%20space%20dark%20background%2C%20mathematical%20formulas%20floating%20in%20hologram%2C%20cool%20blue%20and%20orange%20palette%2C%20digital%20art%20style%2C%20clean%20epic%20composition&width=800&height=1100&seq=cat-comic-17&orientation=portrait",
    category: "科幻",
    slug: "kehuan",
    views: "1300万",
    rating: 9.5,
    tags: ["科幻", "硬科幻"],
  },
  {
    id: 502,
    title: "灵笼",
    author: "艺画开天",
    cover: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20manhua%20scene%20with%20ruined%20city%20and%20giant%20mechanical%20structures%2C%20survivors%20in%20futuristic%20gear%2C%20dusty%20orange%20and%20gray%20palette%2C%20dystopian%20atmosphere%2C%20digital%20art%20style%2C%20clean%20cinematic%20composition&width=800&height=1100&seq=cat-comic-18&orientation=portrait",
    category: "科幻",
    slug: "kehuan",
    views: "880万",
    rating: 9.3,
    tags: ["科幻", "末日"],
  },
  {
    id: 503,
    title: "吞噬星空",
    author: "我吃西红柿",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20space%20battle%20scene%20with%20giant%20mecha%20and%20alien%20creatures%2C%20explosions%20and%20laser%20beams%2C%20epic%20scale%20battle%2C%20cool%20blue%20and%20orange%20light%20effects%2C%20digital%20art%20style%2C%20clean%20action-packed%20composition&width=800&height=1100&seq=cat-comic-19&orientation=portrait",
    category: "科幻",
    slug: "kehuan",
    views: "720万",
    rating: 9.1,
    tags: ["科幻", "机甲"],
  },
  {
    id: 504,
    title: "未来日记",
    author: "えすのサカエ",
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20manhua%20scene%20with%20smartphone%20displaying%20future%20predictions%2C%20glitch%20effects%20and%20digital%20artifacts%2C%20ominous%20red%20glow%2C%20cyberpunk%20atmosphere%2C%20dark%20and%20mysterious%20mood%2C%20digital%20art%20style%2C%20clean%20suspenseful%20composition&width=800&height=1100&seq=cat-comic-20&orientation=portrait",
    category: "科幻",
    slug: "kehuan",
    views: "430万",
    rating: 8.9,
    tags: ["科幻", "惊悚"],
  },
  {
    id: 601,
    title: "凡人修仙传",
    author: "忘语",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20scene%20with%20ordinary%20village%20boy%20cultivating%20immortal%20energy%2C%20misty%20mountains%20and%20flying%20swords%20in%20background%2C%20serene%20and%20mystical%20atmosphere%2C%20traditional%20ink%20wash%20style%20with%20digital%20enhancement%2C%20clean%20ethereal%20composition&width=800&height=1100&seq=cat-comic-21&orientation=portrait",
    category: "仙侠",
    slug: "xianxia",
    views: "1560万",
    rating: 9.7,
    tags: ["仙侠", "修真"],
  },
  {
    id: 602,
    title: "仙逆",
    author: "耳根",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20scene%20with%20a%20lone%20cultivator%20facing%20a%20giant%20celestial%20dragon%20in%20stormy%20skies%2C%20epic%20confrontation%2C%20dark%20clouds%20and%20lightning%2C%20dramatic%20power%20contrast%2C%20digital%20art%20style%2C%20clean%20thrilling%20composition&width=800&height=1100&seq=cat-comic-22&orientation=portrait",
    category: "仙侠",
    slug: "xianxia",
    views: "1100万",
    rating: 9.5,
    tags: ["仙侠", "热血"],
  },
  {
    id: 603,
    title: "从前有座灵剑山",
    author: "国王陛下",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20scene%20with%20a%20floating%20mountain%20peak%20with%20ancient%20temples%20and%20cultivation%20grounds%2C%20clouds%20swirling%20below%2C%20ethereal%20light%20rays%2C%20fantasy%20landscape%2C%20digital%20art%20style%2C%20clean%20magical%20composition&width=800&height=1100&seq=cat-comic-23&orientation=portrait",
    category: "仙侠",
    slug: "xianxia",
    views: "780万",
    rating: 9.2,
    tags: ["仙侠", "搞笑"],
  },
  {
    id: 604,
    title: "诛仙",
    author: "萧鼎",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20romantic%20scene%20with%20two%20cultivators%20in%20flowing%20robes%20standing%20on%20cliff%20edge%20at%20sunset%2C%20golden%20light%20and%20colorful%20clouds%2C%20emotional%20and%20tragic%20atmosphere%2C%20digital%20art%20style%2C%20clean%20poetic%20composition&width=800&height=1100&seq=cat-comic-24&orientation=portrait",
    category: "仙侠",
    slug: "xianxia",
    views: "920万",
    rating: 9.4,
    tags: ["仙侠", "恋爱"],
  },
];

export const allCategories = [
  { name: "全部", slug: "all" },
  { name: "热血格斗", slug: "rexue" },
  { name: "恋爱甜宠", slug: "lianai" },
  { name: "悬疑推理", slug: "xuanyi" },
  { name: "搞笑日常", slug: "gaoxiao" },
  { name: "科幻未来", slug: "kehuan" },
  { name: "仙侠玄幻", slug: "xianxia" },
];

export function getComicsByCategory(slug: string) {
  if (slug === "all") return categoryComics;
  return categoryComics.filter((c) => c.slug === slug);
}